<template>
  <div v-if="domainC && handlesOptions && namserverOptions">
    <h2>{{domainName}}</h2>
    <hr>
    <b-row>
      <b-col>
        <div>
          <i>{{$t('domain.dates.created_at')}}</i>
          <h4>{{domainC['created_at']}}</h4>
        </div>
        <div>
          <i>{{$t('domain.dates.expire')}}</i>
          <h4>{{domainC['expire']}}</h4>
        </div>
      </b-col>
      <b-col v-if="domainC">
        <i class="m-3"><b-link @click="terminateDomain = !terminateDomain ">Kündigung</b-link></i>
        <div class="m-2" v-if="terminateDomain ">
          <b-btn class="m-2" v-if="!domainC['delete'] && ! domainC['suspended_at']" @click="terminateNow(), $forceUpdate()">Sofort Kündigen</b-btn>
          <b-btn class="m-2" v-if="!domainC['delete'] && ! domainC['suspended_at'] " @click="terminateDate()">Zum Auslaufdatum Kündigen</b-btn>
          <b-btn class="m-2" v-if="domainC['suspended_until']" @click="restoreDomain()">Domain Wiederherstellen</b-btn>
          <b-btn class="m-2" v-if="domainC['delete']" @click="undeleteDomain()">Domain Kündigung Wiederrufen</b-btn>
        </div>
      </b-col>
    </b-row>
    <hr>
    <!--GENERAL-->
    <b-row v-if="domainC && handlesKeys" class="mb-3">
      <b-col>
        <table style="min-width: 300px">
          <th><h3>HANDLES</h3></th>
          <tr v-for="(item,key) in domainC"
              :key="key">
            <div v-if="handlesKeys.includes(key)">
              <td >
                <b-link @click="$bvModal.show(key)"><i class="fa fa-pencil"></i></b-link>
                <b-modal  :id="key"
                          hide-footer
                          :title="$t('domain.contacts')[key]">
                  <b>{{handles[key].firstname}} {{handles[key].lastname}}</b>
                  <v-select class="mt-2"
                            v-model="domainC[key]"
                            @input="domainC.local_change = true"
                            :options="handlesOptions"></v-select>
                </b-modal>
              </td>
              <td style="min-width: 180px;">
                <i>{{$t('domain.contacts')[key]}}</i>
              </td>
              <td>
                <b-link @click="$router.push({name:'handle-single-view',params:{handle:domainC[key]}})">
                  <b>{{handles[key].firstname}} {{handles[key].lastname}}</b>
                </b-link>
              </td>
            </div>
          </tr>
        </table>
      </b-col>
    </b-row>

    <b-row v-if="domainC && nameserverKeys" class="mb-3">
      <b-col>
        <table style="min-width: 300px">
          <th><h3>NAMESERVERS</h3></th>
          <tr v-for="(item,key) in domainC"
              :key="key">
            <div v-if="nameserverKeys.includes(key)">
              <td >
                <b-link @click="$bvModal.show(key)"><i class="fa fa-pencil"></i></b-link>
                <b-modal  :id="key"
                          hide-footer
                          :title="$t('domain.nameserver')[key] || $t('domain.optionalNameserver')[key] ">
                  <v-select
                    v-model="domainC[key]"
                    @input="domainC.local_change = true"
                    :options="namserverOptions"></v-select>
                </b-modal>
              </td>
              <td style="min-width: 180px;">
                <i>{{$t('domain.nameserver')[key] || $t('domain.optionalNameserver')[key] }}</i>
              </td>
              <td>
                  {{item || 'option'}}
              </td>
            </div>
          </tr>
        </table>
      </b-col>
    </b-row>

    <!--SAVE BUTTON-->
    <b-row class="mb-4 fixed-bottom footer-summary" v-if="localChange === true">
      <b-col>
        <b-button class="col-12" variant="primary" @click="saveChanges()">
          <h3 v-if="!spinner">Änderungen speichern</h3>
          <b-spinner v-if="spinner"></b-spinner>
        </b-button>
      </b-col>
    </b-row>
    <b-row class="mb-4 fixed-bottom footer-summary" v-if="localChange !== true && localChange !== false">
      <b-col>
        <b-button class="col-12" variant="danger" ><h3>{{localChange}}</h3></b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import {Domain} from "@/store/models/domain/domain"
  import {DomainHandle} from "@/store/models/domain/domain_handle";
  import {DomainNameserver} from "@/store/models/domain/domain_nameserver";

  export default {
    name: "luma-show-domain",
    data:()=>({
      domain:{},
      terminateDomain:false,
      spinner:false,
      termination:false
    }),
    created(){
      Domain.fetch(this.domainName)
      DomainHandle.fetchall()
      DomainNameserver.fetch()
    },
    computed:{
        domainName(){
            return this.$route.params.name
        },
      domainC(){
        if(this.termination ) {
            this.domain = Domain.find(this.domainName)
            this.termination = false
            console.log('TERMINATION', this.domainC)
        }
        if(!Domain.find(this.domainName)) Domain.fetch(this.domainName)
        if(!this.domain.name) {
          const x = Domain.find(this.domainName)
          this.domain = Object.assign({},x)
        }
        return this.domain
      },
      handlesKeys(){
        return Domain.contacts
      },
      handlesOptions(){
        return DomainHandle.all().map(el=>el.handle)
      },
      handles(){
        if(DomainHandle.all().length < 2) DomainHandle.fetchall()
        const y = {}
        const x =  this.handlesKeys.map(el=>{
          y[el] = DomainHandle.fullname(this.domainC[el])
          y['id']=this.domainC[el]
        })
        return y
      },
      nameserver(){
            console.log('NO NAMSERVER IN DOMAINSHOW:::')
        const y = {}
        const x =  this.nameserverKeys.map(el=>{
          y[el] = this.domainC[el]
        })
        return y
      },
      namserverOptions(){
        return DomainNameserver.all().map(el=>el)
      },
      nameserverKeys(){
        return DomainNameserver.nameserverKeys
      },
      localChange(){
        return this.domainC['local_change']
      }

    },
    methods:{
      //save
    saveChanges(){
            this.spinner = true
            const x = Domain.editDomain(this.domainName, this.domainC).then(
                (response)=>{
                    console.log('SAVE DOMAIN RESPONSE::::',response)
                    Domain.fetch(this.domainName)
                    if(Domain.find(this.domainName))this.handleM = Object.assign({},Domain.find(this.domainName))
                    this.domainC.local_change = false
                    this.spinner = false
                }
            ).catch((error)=>{
                console.log('SAVE DOMAIN ERROR RESPONSE::::',error)
                this.domainC.local_change = error.data.messages.errors.map(el=>el.message)
                this.spinner = false
            })
        },

      async terminateNow(){
        //TO DO CATCH AND UPDATE STORE
        const x = await Domain.deleteDomain(this.domainName,false).then((response)=>{
          const update = Domain.updateResponse(response)
            this.termination = true
          console.log('TERMINATE NOW:::')
        }).catch((error)=>{
          console.log('TERMINATE NOW ERROR:::')
        })
        return x

      },
      terminateDate(){
        const expire = this.domainC.expire
        const x = Domain.deleteDomain(this.domainName,expire).then((response)=>{
            const update = Domain.updateResponse(response)
            this.termination = true
            console.log('TERMINATE DATE:::', update)
        }).catch((error)=>{
            console.log('TERMINATE DATE ERROR:::')
        })
          return x
      },
      undeleteDomain(){
        const x = Domain.undeleteDomain(this.domainName).then((response)=>{
            const update = Domain.updateResponse(response)
            this.termination = true
            console.log('TERMINATE UNDELETE:::', update)
        }).catch((error)=>{
            //const update = Domain.fetch(this.domainName)
            console.log('TERMINATE UNDELETE ERROR:::' )
        })
          return x

      },
      restoreDomain(){
        const x= Domain.restoreDomain(this.domainName).then((response)=>{
            const update = Domain.updateResponse(response)
            this.termination = true
            console.log('TERMINATE RESTORE:::', update)
        }).catch((error)=>{
            //const update = Domain.fetch(this.domainName)
            console.log('TERMINATE RESTORE ERROR:::')
        })
          return x
      }
    }
  }
</script>

<style scoped>
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    /*height: 85px;*/
    bottom: 11px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
</style>



// WEBPACK FOOTER //
// src/components/domain/create_domain/luma-show-domain.vue